import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { useCreateDiscount } from 'src/features/discounts/api/useCreateDiscount';
import { LIST_DISCOUNTS_RESOURCE } from 'src/features/discounts/api/useListDiscounts';
import { DISCOUNT_RESOURCE } from 'src/features/discounts/api/useGetDiscount';
import { discountsMessages } from 'src/features/discounts/utils/messages';
import DiscountFormModal from 'src/features/discounts/components/forms/DiscountFormModal';

interface CreateDiscountFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateDiscountFormModal<TData>({ className, semantics }: CreateDiscountFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateDiscount({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_DISCOUNTS_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [DISCOUNT_RESOURCE] });
            toast({
                title: formatMessage(discountsMessages.createDiscountSuccess),
                description: formatMessage(discountsMessages.createDiscountSuccessDescription),
            });
        },
    });

    return (
        <DiscountFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(discountsMessages.addDiscountSubtitle)}
        />
    );
}

export default CreateDiscountFormModal;
